import { Link } from 'react-router-dom';
import { fmtBytes, fmtNumber, Section, StatCard, TypeBadge } from './parts';

export type TableObj = {
  schema: string;
  name: string;
  type: 'table';
  on_disk_bytes: number;
  heap_bytes: number;
  index_bytes: number;
  rows: number;
};

export function DetailTable({ obj }: { obj: TableObj }) {
  const fqn = `${obj.schema}.${obj.name}`;
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div className="flex items-center gap-3">
          <Link to="/db" className="text-sm text-muted-foreground hover:text-foreground">
            ← Retour
          </Link>
          <h2 className="text-xl font-bold font-mono">{fqn}</h2>
          <TypeBadge type={obj.type} />
        </div>
        <span className="text-xs text-muted-foreground">VACUUM via « Actions globales » (queue ingest)</span>
      </div>

      <Section title="Tailles">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          <StatCard label="Total disque" value={fmtBytes(obj.on_disk_bytes)} tone="primary" />
          <StatCard label="Heap" value={fmtBytes(obj.heap_bytes)} />
          <StatCard label="Index" value={fmtBytes(obj.index_bytes)} />
          <StatCard label="Lignes (approx)" value={fmtNumber(obj.rows)} />
        </div>
      </Section>

      <Section title="Informations">
        <div className="text-sm text-muted-foreground">
          Table PostgreSQL standard. Pas de chunking ni de compression Timescale.
          <br />
          Pour stats détaillées par colonne, voir <code className="font-mono">pg_stats</code>.
        </div>
      </Section>
    </div>
  );
}
